import { clamp, mix } from "../utils/math.ts";

export const SCALE_MIN = 0.72;
export const SCALE_MAX = 1.72;
export const SCALE_BASE = 1;

export const ENERGY_MIN = 0.2;
export const ENERGY_MAX = 1;
export const ENERGY_BASE = 0.74;

export const POINT_SIZE_MIN = 2.4;
export const POINT_SIZE_MAX = 8;
export const PIXEL_RATIO_MAX = 1.75;

export const BLOOM_STRENGTH = 0.5;
export const BLOOM_RADIUS = 0.22;
export const BLOOM_THRESHOLD = 0.58;
export const TONE_EXPOSURE = 1;

export const CAMERA_Z = 14.2;
export const CAMERA_Y = 0.55;
export const CAMERA_FOV = 52;
export const FORMATION_RADIUS = 4.5;
export const IDLE_SPIN = 0.11;

export const TWO_HAND_EXPAND_START = 0.52;
export const TWO_HAND_EXPAND_END = 0.86;

export const GESTURE_NEUTRAL_MS = 400;

export const EXPOSURE_MIN = 0.75;
export const EXPOSURE_MAX = 1.12;
export const BLOOM_STRENGTH_MAX = 0.68;
export const POINT_SIZE_MULT_MIN = 0.75;
export const POINT_SIZE_MULT_MAX = 1.35;

export function clampScale(value: number): number {
  return clamp(value, SCALE_MIN, SCALE_MAX);
}

export function clampEnergy(value: number): number {
  return clamp(value, ENERGY_MIN, ENERGY_MAX);
}

export function clampPointSize(value: number): number {
  return clamp(value, POINT_SIZE_MIN, POINT_SIZE_MAX);
}

export function clampExposure(value: number): number {
  return clamp(value, EXPOSURE_MIN, EXPOSURE_MAX);
}

/** Map two-hand span to 0–1 expansion. Neutral below TWO_HAND_EXPAND_START. */
export function expansionFromHandSpan(span: number): number {
  return clamp(
    (span - TWO_HAND_EXPAND_START) / (TWO_HAND_EXPAND_END - TWO_HAND_EXPAND_START),
    0,
    1,
  );
}

export function scaleFromExpansion(amount: number): number {
  return clampScale(mix(1.08, SCALE_MAX, clamp(amount, 0, 1)));
}

export function energyFromExpansion(amount: number): number {
  return clampEnergy(mix(0.76, 0.96, clamp(amount, 0, 1)));
}

export function scaleFromPinch(amount: number): number {
  return clampScale(mix(1.06, 0.74, clamp(amount, 0, 1)));
}

export function energyFromPinch(amount: number): number {
  return clampEnergy(mix(0.7, 0.9, clamp(amount, 0, 1)));
}

export function scaleFromPalm(): number {
  return 1.2;
}

export function energyFromPalm(): number {
  return 0.9;
}

/** NDC radius → viewport coverage (0–1 of frame height). */
export function viewportCoverage(radius: number, cameraZ: number, fovDeg: number): number {
  const tan = Math.tan((fovDeg * Math.PI) / 360);
  return clamp(radius / Math.max(0.01, cameraZ * tan), 0, 2);
}
